import { DateTime } from "luxon";
require("luxon-parser");

//import store from "@/store";

Date.isLeapYear = function (year) {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
};

Date.getDaysInMonth = function (year, month) {
  return [
    31,
    Date.isLeapYear(year) ? 29 : 28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31,
  ][month];
};

Date.prototype.isLeapYear = function () {
  const dt = DateTime.fromJSDate(this);
  return dt.isValid ? Date.isLeapYear(dt.year) : false;
};

Date.prototype.getDaysInMonth = function () {
  const dt = DateTime.fromJSDate(this);
  return dt.isValid ? Date.getDaysInMonth(dt.year, dt.month - 1) : 0;
};

Date.prototype.addMonths = function (value) {
  const dt = DateTime.fromJSDate(this);
  if (!dt.isValid) return this;
  const day = dt.day;
  const shifted = dt.startOf("month").plus({ months: value });
  const next = shifted.set({ day: Math.min(day, shifted.daysInMonth) });
  this.setTime(next.toMillis());
  return this;
};

const DatesHelpers = (function () {
  return {
    dateFromIsoToLocale: function (value, locale) {
      if (!value) return null;
      const d = DateTime.fromISO(value);
      return d.setLocale(locale).toLocaleString(DateTime.DATE_SHORT);
    },

    validateDate: function (date, locale) {
      if (!date) return false;
      const res = DateTime.fromAny(date, { locale: locale });
      return res.invalid;
    },

    dateFromLocaleToIso: function (date, locale) {
      try {
        let parts = date.split("-");
        let year = parts[2];
        let month = parts[0];
        let day = parts[1];
        if (locale.toLowerCase().substr(0, 2) == "it") {
          parts = date.split("/");

          year = parts[2];
          month = parts[1];
          day = parts[0];
        }
        const isoDate = `${year}-${month.padStart(2, "0")}-${day.padStart(
          2,
          "0"
        )}`;
        return isoDate;
      } catch {
        return null;
      }
    },

    mysql2JsDate: function (str) {
      if (!str) return null;
      const parsed = DateTime.fromSQL(String(str), { zone: "local" });
      return parsed.isValid ? parsed.toJSDate() : null;
    },

    mysql2JsLocal: function (str) {
      if (!str) return null;
      const parsed = DateTime.fromSQL(String(str), { zone: "utc" });
      return parsed.isValid ? parsed.toLocal().toJSDate() : null;
    },

    getDayOfWeek: function (d) {
      if (!d) return null;
      const parsed =
        d instanceof Date
          ? DateTime.fromJSDate(d)
          : DateTime.fromISO(String(d));
      if (!parsed.isValid) return null;
      return parsed.weekday;
    },

    formatDate: function (d) {
      if (!d) return null;
      const parsed =
        d instanceof Date
          ? DateTime.fromJSDate(d)
          : DateTime.fromISO(String(d));
      return parsed.isValid ? parsed.toFormat("yyyy-LL-dd") : null;
    },

    formatTime: function (d) {
      if (!d) return null;
      const parsed =
        d instanceof Date
          ? DateTime.fromJSDate(d)
          : DateTime.fromISO(String(d));
      return parsed.isValid ? parsed.toFormat("HH:mm") : null;
    },

    getDateTime: function (strDate, strTime) {
      const parsed = DateTime.fromSQL(
        `${String(strDate || "").trim()} ${String(strTime || "").trim()}`,
        { zone: "local" }
      );
      return parsed.isValid ? parsed.toJSDate() : null;
    },
  };
})();

export default DatesHelpers;
